import React, { Component } from 'react';
import axios from 'axios';
import { CustomNav } from '../Components/CustomNav';
import { RosterTable } from '../Components/RosterTable';
import { PlayerCard } from '../Components/PlayerCard';
import { PlayerCardExpanded } from '../Components/PlayerCardExpanded';
import { NonRosteredTable } from '../Components/NonRosteredTable';
import { makeData } from '../Utility/utility.js';
import './TeamManagement.css';
import { teamsData } from '../Pages/dataUrls';
import { AppContext } from '../Pages/App';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';
//let homeTeam = require('../Mock/team-management-caps-pos.json');
//let awayTeam = require('../Mock/team-management-pit.json');
//let awayTeam2 = require('../Mock/reorder-positions.json');x

const teamUrl = React.createContext(apiServerUrl + '/get_team_players?team=');
const playerUrl = React.createContext(apiServerUrl + '/player_card?player_id=');

export class Players extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedPlayer: '',
      selectedPlayerStats: []
    };
    //this.toggleActive = this.toggleActive.bind(this);
    //this.addPlayer = this.addPlayer.bind(this);
  }
  getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }
  componentDidMount() {
    let e = this.getParameterByName('player_id');
    let incomingPlayerID = e;
    let currentComponent = this;
    axios
      .get(
        apiServerUrl + '/player_card?player_id=' + incomingPlayerID,
        requestOptions()
      )
      .then(function(response) {
        //console.log(response.data);
        if (response.data) {
          currentComponent.setState({
            selectedPlayer: response.data
          });
        }
      })
      .catch(function(error) {
        //console.log(error);
      });
  }

  render() {
    return (
      <div>
        <header className="nav">
          <CustomNav />
        </header>
        {/* Bottom Row */}
        <div className="team-flex-grid" style={{ marginBottom: '1em' }}>
          <div className="player gutter-right" style={{ flex: 6 }}>
            {this.state.selectedPlayer && (
              <PlayerCardExpanded selectedPlayer={this.state.selectedPlayer} />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Players;



// WEBPACK FOOTER //
// ./src/Pages/Players.js